import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // error UI is rendered via state; avoid leaking details to console
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', background: 'linear-gradient(180deg, #FFEDDA 0%, #FFFFFF 60%)', padding: '2rem', textAlign: 'center'
        }}>
          <div style={{
            width: '64px', height: '64px', borderRadius: '50%', display: 'flex', alignItems: 'center',
            justifyContent: 'center', background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.25)', marginBottom: '1.5rem'
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h1 style={{ fontFamily: "'Outfit', sans-serif", fontSize: '1.5rem', color: '#302B2C', marginBottom: '0.75rem', fontWeight: 800, letterSpacing: '-0.03em' }}>
            Something went wrong
          </h1>
          <p style={{ fontFamily: "'Manrope', sans-serif", color: 'rgba(48,43,44,0.72)', fontSize: '0.9375rem', maxWidth: '420px', marginBottom: '2rem', lineHeight: 1.6 }}>
            We hit an unexpected error. Your progress on the server is safe — please restart the assessment.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              data-testid="error-boundary-retry-btn"
              onClick={() => { window.location.href = '/upload'; }}
              style={{
                padding: '0.75rem 1.75rem', borderRadius: '2px', border: 'none', cursor: 'pointer',
                background: 'linear-gradient(135deg, #F67425, #BB0518)', color: '#fff', fontSize: '0.9375rem', fontWeight: 700,
                boxShadow: '0 4px 16px rgba(246,116,37,0.25)'
              }}
            >
              Restart Assessment
            </button>
            <button
              data-testid="error-boundary-home-btn"
              onClick={() => { window.location.href = '/'; }}
              style={{
                padding: '0.75rem 1.75rem', borderRadius: '2px', cursor: 'pointer',
                background: 'transparent', color: 'rgba(48,43,44,0.72)', fontSize: '0.9375rem', fontWeight: 700,
                border: '1px solid rgba(48,43,44,0.18)'
              }}
            >
              Go Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
